import React from "react";
import Accordion from "./Accordion";
import AccordionItem from "./AccordionItem";

const ProgrammeFormat = () => {
  const programmeItems = [
    {
      title: "Duration",
      heading: "Programmes are designed to accommodate varying schedules:",
      bulletItems: [
        "Intensive Delivery: Complete the programme in 4–10 days, depending on the course content and participant needs.",
        "Flexible Modular Sessions: Spread learning over multiple weeks with shorter sessions to fit professional schedules.",
      ],
    },
    {
      title: "Learning Methods",
      paragraphs: [
        "Flexible Modular Sessions: Spread learning over multiple weeks with shorter sessions to fit professional schedules.",
        "Real-world case studies focusing on African and global governance challenges.",
        "Collaborative group projects to enhance team-based problem-solving skills.",
        "Immersive simulations of diplomatic negotiations, policy-making, and governance scenarios.",
        "Expert-led lectures combining theory and practice for actionable insights.",
      ],
    },
    {
      title: "Target Participants",
      paragraphs: [
        "Senior government officials, diplomats, and policymakers.",
        "Public sector leaders who influence or directly manage governance processes.",
        "Stakeholders from civil society organisations, international agencies, and corporate governance roles.",
      ],
    },
    {
      title: "Location & Delivery",
      paragraphs: [
        "In-Person: Conducted at prestigious training facilities or host institutions.",
        "Blended: A combination of online sessions and in-person workshops for flexibility.",
      ],
    },
    {
      title: "Group Forum",
      heading: "Programmes are designed to accommodate varying schedules:",
      bulletItems: [
        "Share best practices in governance, policy, and leadership.",
        "Build professional networks for ongoing collaboration.",
        "Learn from diverse perspectives on regional and global challenges.",
      ],
    },
    {
      title: "Educational Visits",
      heading: "Programmes are designed to accommodate varying schedules:",
      bulletItems: [
        "Visit relevant institutions such as European Union bodies, UN agencies, and local governance hubs.",
        "Observe governance practices in real-world settings.",
        "Identify best practices that can be adapted to their home countries.",
      ],
    },
    {
      title: "Programme Support & Networking",
      paragraphs: [
        "Alumni Network: Graduates join a global network of governance professionals for continuous learning and opportunities.",
        "Expert Mentoring: Access to mentors during and after the programme for professional development.",
      ],
    },
  ];

  return (
    <div className="bg-[#4A627C]">
      <div className="max-w-6xl mx-auto md:p-10 p-3 space-y-5">
        <div>
          <p className="text-white font-bold text-lg md:text-xl ">
            Programme Format
          </p>
        </div>
        <div className="bg-sdbodywhiteywhitebody h-0.5 w-10 my-2"></div>
        <Accordion>
          {programmeItems.map((item, index) => (
            <AccordionItem key={index} title={item.title}>
              {item.bulletItems ? (
                <div className="text-white text-sm md:text-base">
                  {item.heading && (
                    <p className="bg-[#006CDF] border-t-2 border-t-black p-2 inline-block">
                      {item.heading}
                    </p>
                  )}
                  <ul className="mt-2 space-y-2">
                    {item.bulletItems.map((bullet, i) => (
                      <li key={i} className="flex items-start space-x-2">
                        <div className="mt-1">
                          <svg
                            className="w-6 h-6 text-black"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        </div>
                        <p className="text-black">{bullet}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : item.paragraphs ? (
                <div className="text-white space-y-1">
                  {item.paragraphs.map((para, i) => (
                    <p
                      key={i}
                      className="p-2 border-l-2 border-black bg-[#498ED8]"
                    >
                      {para}
                    </p>
                  ))}
                </div>
              ) : (
                item.content
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default ProgrammeFormat;
